import React, { Component } from 'react';
import { CheckCircle } from 'lucide-react';
export function AboutSection() {
  return <section id="about" className="py-20 md:py-32 bg-white" data-id="element-9">
      <div className="container mx-auto px-4 md:px-6" data-id="element-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-11">
          <div className="relative" data-id="element-12">
            <div className="relative z-10 rounded-lg overflow-hidden shadow-2xl" data-id="element-13">
              <img src="https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80" alt="Global trade operations" className="w-full h-auto object-cover" data-id="element-14" />
            </div>
            {/* Decorative element */}
            <div className="absolute -bottom-6 -right-6 w-2/3 h-2/3 bg-[#f0f4f5] -z-10 rounded-lg" data-id="element-15"></div>
            <div className="absolute -top-6 -left-6 w-32 h-32 bg-[#d4a017]/10 rounded-full -z-10 blur-2xl" data-id="element-16"></div>
          </div>

          <div data-id="element-17">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1a4d5c] mb-6" data-id="element-18">
              Diversified Trading <br data-id="element-19" />
              <span className="text-[#d4a017]" data-id="element-20">Across Key Sectors</span>
            </h2>

            <p className="text-gray-600 text-lg mb-6 leading-relaxed" data-id="element-21">
              Manifold Trade is a specialized wholesale trading company
              operating across energy, automotive, and mobility sectors. We
              facilitate connections between suppliers and buyers across
              international markets.
            </p>

            <p className="text-gray-600 text-lg mb-8 leading-relaxed" data-id="element-22">
              Our operations span from traditional energy products to emerging
              electric vehicle technologies, supported by market knowledge and
              strategic partnerships.
            </p>

            <div className="space-y-4" data-id="element-23">
              {['Energy & Wholesale Trading', 'Automotive Components', 'EV & Mobility Solutions', 'Supply Chain Coordination'].map((item, index) => <div key={index} className="flex items-center gap-3" data-id="element-24">
                  <CheckCircle className="text-[#d4a017] flex-shrink-0" size={20} data-id="element-25" />
                  <span className="text-[#1a4d5c] font-medium" data-id="element-26">{item}</span>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}